<script setup>
import { onMounted, watch } from 'vue';
import FormButton from '../Atoms/FormButton.vue';
import { useVodStorageUsage } from '@/composables/useVodStorageUsage';
import bgImg from '@/assets/images/plan-limit-bg.png';
import folderLockImg from '@/assets/images/plan-limit-folder-lock.png';

// The same account-wide figure the Storage indicator shows. The allowance is
// shared by every workspace, so the banner is due in all of them — not only in
// whichever workspace happens to hold the videos that filled it.
const { isExceeded: overLimit, storageSubscription, fetchUsage } = useVodStorageUsage();

onMounted(fetchUsage);
watch(storageSubscription, fetchUsage);
</script>

<template>
	<div v-if="overLimit"
		class="plan-limit-banner relative overflow-hidden flex flex-col gap-4 rounded-xl p-4 mb-5 ring-1 ring-white/5 md:flex-row md:items-center"
		:style="{ backgroundImage: `url(${bgImg})` }">
		<div class="flex items-center gap-4 min-w-0 flex-1">
			<img :src="folderLockImg" alt="" class="shrink-0 w-[52px] h-[48px] object-contain" />
			<div class="min-w-0">
				<p class="text-base font-semibold text-white">You've reached your plan limit</p>
				<p class="text-sm text-surface-8 mt-0.5">Upgrade your plan to keep streaming and uploading without
					interruption.</p>
			</div>
		</div>
		<div class="shrink-0 flex items-center justify-end gap-2">
			<a href="/app/subscribe?category=live" class="hover:no-underline">
				<FormButton type="main">Upgrade plan</FormButton>
			</a>
			<a href="/app/subscribe?category=live" class="hover:no-underline">
				<FormButton type="secondary">View plans</FormButton>
			</a>
		</div>
	</div>
</template>

<style scoped>
.plan-limit-banner {
	background-color: #000000;
	background-repeat: no-repeat;
	background-position: left center;
	background-size: cover;
}
</style>
